import { ResearchFilterMunicipalNumberVM } from 'civil-status/view-models/municipal-number';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';

export const transformerResearchMunicipalNumber = (
  values: ResearchFilterMunicipalNumberVM
  // page?: number,
  // rowsPerPage?: number
): string => {
  const transformedFilters: OperationObject = {
    registro: {
      value: values?.register || '',
      operation: Operation.EQUALS,
    },
    richiestaDa: {
      value: values?.dateFrom ? values.dateFrom.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    richiestaA: {
      value: values?.dateTo ? values.dateTo.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    operatore: {
      value: values?.operator || '',
      operation: Operation.EQUALS,
    },
    stato: {
      value: values?.state || '',
      operation: Operation.EQUALS,
    },
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    // page,
    // rowsPerPage,
  })}`;
};
